// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Highlights20 from './Highlights20.tsx';
import Highlights20Filled from './Highlights20Filled.tsx';
import Highlights24 from './Highlights24.tsx';
import Highlights24Filled from './Highlights24Filled.tsx';
import Highlights40 from './Highlights40.tsx';
import Highlights40Filled from './Highlights40Filled.tsx';
import Highlights48 from './Highlights48.tsx';
import Highlights48Filled from './Highlights48Filled.tsx';

type HighlightsProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Highlights20,
    Highlights20Filled,
    Highlights24,
    Highlights24Filled,
    Highlights40,
    Highlights40Filled,
    Highlights48,
    Highlights48Filled,
};

const Highlights: FC<HighlightsProps> = ({ variation, ...props }) => {
    const variationKey = `Highlights${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Highlights" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Highlights;
